import React from 'react'
import PropTypes from 'prop-types'
import { Form, Select } from 'antd'
import css from './contact-mapping.css'

const { Option } = Select

const DoctorSelect = ({ onDoctorSelect, doctors, doctorId, isOpenDental }) => {
  const filteredDoctors = doctors.filter(
    doctor =>
      ['Doctor', 'Dr.', 'Dr'].includes(doctor.title) &&
      doctor.preferred_name !== 'UNKNOWN UNKNOWN',
  )

  return (
    <div className={css.defaultDoctorWrapper}>
      <span className={css.labelSmall}>Online Scheduling Default Doctor</span>
      <Form.Item className={css.formItem}>
        <Select
          style={{ width: '230px' }}
          onChange={onDoctorSelect}
          value={doctorId || ''}
          name="doctorId"
          disabled={isOpenDental}
        >
          <Option value="">
            {isOpenDental ? 'Assigned per operatory' : 'None'}
          </Option>
          {filteredDoctors.map(doctor => (
            <Option value={doctor.id} key={doctor.id}>
              {doctor.preferred_name}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </div>
  )
}

DoctorSelect.propTypes = {
  doctors: PropTypes.arrayOf(
    PropTypes.shape({
      preferred_name: PropTypes.string,
      title: PropTypes.string,
    }),
  ).isRequired,
  doctorId: PropTypes.string,
  onDoctorSelect: PropTypes.func.isRequired,
  isOpenDental: PropTypes.bool.isRequired,
}

DoctorSelect.defaultProps = {
  doctorId: null,
}

export default DoctorSelect



// WEBPACK FOOTER //
// ./src/AddPractice/Associations/DoctorSelect.js